export default {}.install = (Vue = {}) => {
  Vue.directive("scroll", {
    inserted(el, binding) {
      const SELECT_WRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      SELECT_WRAP_DOM.addEventListener('scroll', function () {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (CONDITION) {
          binding.value();
        }
      });
    },
  });
};
